export default "__VITE_ASSET__CQPWtJHq__"